import React, { useState, useEffect } from 'react'
import { Button, Radio, Input, Spin, message } from 'antd'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'

import PopupWrapper from './PopupWrapper'
import DealsActions from '../../Redux/DealsRedux'
import './PopupPage.less'

const { TextArea } = Input;

const radioStyle = {
  display: 'block',
  lineHeight: '30px',
  marginBottom: 20,
  font: 'normal normal 500 15px/24px Poppins'
};

const radioOptions = [
  'The target appointed a financial Advisor',
  'The target decided not to sell anymore',
  'Other (please specify)'
];

function WithDrawAdvisorPopupPage(props) {
  const { result, fetching, isAdmin, match } = props;
  const { dealId } = match.params;

  const [value, setValue] = useState(null);
  const [other, setOther] = useState(null);

  const history = useHistory();

  function handleClose() {
    if (isAdmin) {
      // props.getDeal(dealId);
      history.push(`/home/deal-pipeline`);
    } else {
      history.push('/home/deals');
    }
  }

  useEffect(() => {
    if (result) {
      handleClose();
    }
  }, [result]);

  const checkRequired = () => {
    if (value == null || (value === 2 && !other)) {
      message.error('Choose a reason', 3);
    } else {
      const data = {
        withdraw_reason: value === 2 ? other : radioOptions[value]
      };
      props.withdrawDeal(dealId, data);
    }
  }

  return (
    <PopupWrapper
      width={460}
      path={isAdmin ?
          `/home/deal-details/${dealId}/info`
        :
          `/home/deal/${dealId}/summary`
      }
    >
      <Spin spinning={fetching} size="large">
        <div className="dialog-content" style={{ padding: '24px 48px' }}>
          <div className="dialog-title deal">Withdraw Deal</div>
          <div className="deal-text">We are sorry to hear that you want to withdraw this deal. Please provide us with the reason for the withdrawn:</div>
          <br />
          <Radio.Group
            onChange={(e) => setValue(e.target.value)}
          >
            {
              radioOptions.map((el, i) => (
                <Radio style={radioStyle} value={i} key={i}>
                  {el}
                </Radio>
              ))
            }
          </Radio.Group>
          <div className="area-block">
            <span>Insert reason</span>
            <TextArea
              className={value === 2 && !other && 'error-input'}
              rows={4}
              disabled={value !== 2}
              onBlur={(e) => setOther(e.target.value)}
            />
          </div>
          <div className="btn-footer" style={{ marginTop: 24 }}>
            <Button type="primary white" className="btn-primary" onClick={checkRequired}>
              Confirm
          </Button>
          </div>
        </div>
      </Spin>
    </PopupWrapper>
  )
}

const mapStateToProps = (state) => {
  return {
    result: state.deals.dealWithdrawResult,
    fetching: state.deals.fetching,
    isAdmin: state.auth.isAdmin,
  }
}

const mapDispatchToProps = (dispatch) => ({
  withdrawDeal: (id, data) => dispatch(DealsActions.dealWithdrawRequest(id, data)),
  getDeal: (id) => dispatch(DealsActions.dealRequest(id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(WithDrawAdvisorPopupPage)
